var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.9C17 14.967 15.5076 13.4 13.6667 13.4H10.3333C8.49238 13.4 7 14.967 7 16.9V18.3C7 18.6866 7.29848 19 7.66667 19H16.3333C16.7015 19 17 18.6866 17 18.3V16.9Z",
    fill: "#0D0D0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 8.85C15.6667 6.7237 14.025 5 12 5C9.97496 5 8.33333 6.7237 8.33333 8.85C8.33333 10.9763 9.97496 12.7 12 12.7C14.025 12.7 15.6667 10.9763 15.6667 8.85Z",
    fill: "#0D0D0D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPicture);
export default __webpack_public_path__ + "static/media/no-picture.4b6ed758f108442d28be5ea2979fe31b.svg";
export { ForwardRef as ReactComponent };